const dataWork = [
  {
    id: 1,
    numb: "01",
    title: "Set up your wallet",
    text: `To connect with TronAI, let's prepare a WEB 3 wallet belonging to the Arbitrum Network. For example Metamask, Trust Wallet,...`,
  },
  {
    id: 2,
    numb: "02",
    title: "Connect With TronAI",
    text: "Connect your blockchain wallet to TronAI, sign, and start the process of describing the unique image you want the AI to generate for you",
  },
  {
    id: 3,
    numb: "03",
    title: "Mint A Unique NFT Collection",
    text: `Just click the "Mint NFT" button and pay a small GAS fee. Once the process is complete, the image you selected will be mint to NFT`,
  },
  {
    id: 4,
    numb: "04",
    title: "Sell Your NFT's",
    text: "BASEAI",
  },
];
export default dataWork;
